import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs';
import {Permissions} from '../../shared/models/permissions.model';
import {RawPermissions} from '../../shared/models/raw-permissions.model';
import {SessionStorageService} from '../../shared/services/session-storage.service';
import {OAuthService} from '../../shared/services/authorization/oauth.service';
import {PermissionService} from '../../shared/services/permission.service';

@Component({
  selector: 'sub-header',
  templateUrl: './sub-header.component.html'
})
export class SubHeaderComponent implements OnInit, OnDestroy {

  @Output() public toggleMenu: EventEmitter<any> = new EventEmitter();
  @Output() public detectMobileSize: EventEmitter<any> = new EventEmitter();
  @Output() public processingLogout: EventEmitter<any> = new EventEmitter();


  public username: string;
  public isMainHeaderNarrow = false;
  public logoutIsWaiting = false;
  public isLoggedIn = true;

  private usernameSubscription: Subscription;

  public permissions: Permissions;

  public companies: Array<string>;
  public rawPermissions: Array<RawPermissions>;
  public rawPermissionsSubscription: Subscription;

  constructor(private sessionStorage: SessionStorageService,
              private oauthService: OAuthService,
              private permissionService: PermissionService) { }

  ngOnInit() {
    this.usernameSubscription = this.sessionStorage.usernameChange.subscribe((username) => {
      this.username = username;
    });

    this.permissionService.permissions$.subscribe((permissions: Permissions) => {
      if (permissions) {
        this.permissions = permissions;
      }
    });

    this.rawPermissionsSubscription = this.permissionService.rawPermissions$.subscribe( rawPermissions => {
      if (rawPermissions) {
        this.rawPermissions = rawPermissions;
        this.companies = rawPermissions.map( el => el.companyName );
      }
    });
  }

  ngOnDestroy(): void {
    this.usernameSubscription.unsubscribe();
  }

  public checkForMobileBrowser() {
    this.detectMobileSize.emit();
  }

  public displayNarrowMainHeader(event) {
    this.isMainHeaderNarrow = event;
  }

  public toggleDropdown() {
    this.toggleMenu.emit();
  }


  public logout() {
    this.processingLogout.emit();
    this.logoutIsWaiting = true;
    this.oauthService.signOut();
  }

}
